import _ from 'underscore'

const getRegion = ( points, padding = 0.005, proportion ) => {

  const aux = points
    .map( ( [ lon, lat ] ) => ( {
      lat,
      lon
    } ) )

  const maxLat = _.max( aux, 'lat' )
  const minLat = _.min( aux, 'lat' )
  const maxLon = _.max( aux, 'lon' )
  const minLon = _.min( aux, 'lon' )

  return [
    [ minLat.lon - padding, minLon.lat - padding ],
    [ maxLat.lon + padding, maxLon.lat + padding ]
  ]
}

export default getRegion
